import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Avatar from 'components/common/Avatar';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

const EditUser = () => {
  const { id } = useParams();
  const [picture_profile, setPictureProfile] =  React.useState(null);
    
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: null,
    lastName: null,
    email: null,
    phone: null, 
    type : null
   });

  useEffect(()=> {
    // firebase.auth().onAuthStateChanged((user) => {
      if (id)  {
        firebase.firestore().collection('users').doc(id).get().then(doc => {
          if (doc){ 
            let d = doc.data()
            d.id = doc.id;
            setFormData(d) 
          }
        })
      }else{
        toast.error('Une erreur s\'est produite.');
      }
    // })
  }, [])

  const handleChange = e => { 
    let d = {id: formData.id};
    d.firstName = formData.firstName;
    d.lastName = formData.lastName;
    d.email = formData.email;
    d.phone = formData.phone;
    d[e.target.name] = e.target.value;
    if (e.target.name === "type"){
      d[e.target.name] =  e.target.checked ? "partenaire" : "admin" ;
    }
    setFormData(d); 
  };

  const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';


  function generateString(length) {
    let result = '';
    const charactersLength = characters.length;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
  
    return result;
    } 
  const sendFile = async (file, cb) => {
    const storage = firebase.storage();
    const metadata = {
      contentType: file.type,
    };
 
    const ss = `files/${generateString(10)}.${file?.type?.split("/")[1]}`;
    const reference = storage.ref(ss);

 
        const uploadTask = reference.put(file, metadata);

            uploadTask.on(
              firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
              (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${  progress  }% done`);
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log("Upload is paused");
                    break;
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    console.log("Upload is running");
                    break;
                  default :
                    break;
                }
              },
              (err) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (err.code) {
                  case "storage/unauthorized":
                    console.error("err", err)
                    // User doesn't have permission to access the object
                    alert(
                      "Une erreur est survenue lors de l'envoie de votre fichier, vous n'avez pas l'autorisation d'envoyez des documents."
                    );
                    break;
                  case "storage/canceled":
                    // User canceled the upload alert(
                    alert(
                      "Une erreur est survenue lors de l'envoie de votre fichier, vous avez annuler l'envoie."
                    );
                    break;

                  // ...

                  case "storage/unknown":
                    // Unknown error occurred, inspect error.serverResponse
                    alert(
                      "Une erreur est survenue lors de l'envoie de votre fichier, réessayer plus tard."
                    );
                    break;
                  default :
                    break;
                }
              },
              () => {
                console.log("Image uploaded to the bucket!");



                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(async (downloadURL) => {
                    cb(downloadURL)
                  });
              }
            ); 


  }; 

  const handleSubmit = e => {
    e.preventDefault();  
    if (formData && formData.firstName && formData.lastName && formData.phone && formData.id){
      const da = {
        firstName : formData.firstName, 
        lastName:formData.lastName , 
        phone : formData.phone, 
        update_At: new Date(),
        type : formData.type === undefined ? 'admin' : formData.type
      }
      setLoading(true);
      // console.log(da);
      if (formData?.picture_profile_update){   
        sendFile(formData?.picture_profile_update, async (downloadURL) => { 
           firebase.firestore().collection('users').doc(formData.id).update({picture_profile:downloadURL})
           let ps = formData
           ps.picture_profile = downloadURL;
           setFormData(ps)
           toast.success('Mise à jour de la photo de profil');                     
       }); 
     }
      firebase.firestore().collection('users').doc(formData.id).update(da).then((res) => {
        setLoading(false);
        toast.success('Mise à jour terminé'); 
      }).catch(err => {
        setLoading(false);
        toast.error('Une erreur s\'est produite.');
      })
    }else{
      setLoading(false);
      toast.error('Veuillez remplir tout les champs.');
    }
  };

  return (
    <Card>
      <FalconCardHeader title="Edition du profil" />
      <Card.Body className="bg-body-tertiary">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3 g-3">
          {formData?.picture_profile && (
                <Form.Group controlId="formFile" className="mb-3" as={Col} md="1"  >
                      <Form.Label>Actuel</Form.Label>
                      <Avatar src={formData?.picture_profile} className="me-2" size="2xl" />
                </Form.Group>
              )}
              <Form.Group controlId="formFile" className="mb-3" as={Col} md="8"  >
                      <Form.Label>Photo de profile</Form.Label>
                      <Form.Control type="file" name="picture_profile" accept="image/png, image/gif, image/jpeg" 
                    onChange={(value) => {
                        setPictureProfile(value?.target?.files)
                        let d = {...formData};
                        d.picture_profile_update =  value?.target?.files[0]
                        setFormData(d); 
                        console.log("picture_profile_update", d)
                        
                    }}  />
              </Form.Group>
              
            <Form.Group as={Col} lg={6} controlId="firstName">
              <Form.Label>Prénom</Form.Label>
              <Form.Control
                type="text"
                placeholder="Prénom"
                value={formData.firstName}
                name="firstName"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="lastName">
              <Form.Label>Nom de famille</Form.Label>
              <Form.Control
                type="text"
                placeholder="Last Name"
                value={formData.lastName}
                name="lastName"
                onChange={handleChange}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3 g-3">
            <Form.Group as={Col} lg={6} controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={formData.email}
                name="email"
                disabled
                // onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="phone">
              <Form.Label>Téléphone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Phone"
                value={formData.phone}
                name="phone"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Check 
                    type="switch"
                    name="type"
                    value={formData.type === "partenaire"}
                    onChange={handleChange}
                label="C'est un compte partenaire" 
                />
            </Form.Group>
          </Row> 

          <div className="text-end">
            <Button variant="primary" type="submit" disabled={loading}>
              {!loading ? 'Mise à jour': 'Chargement'}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default EditUser;
